import request from '@/util/request';

export const getRegionList = params => {
  return request({
    url: '/api/v4ward/car/ParkSpace/merge/regions',
    method: 'get',
    params: params
  });
};
export const getParkParent = (params, options) =>
  request.get(
    '/api/v4ward/car/ParkSpace/merge/regionParentNodes',
    Object.assign({}, options, { params })
  );
//获取区域
export const loadRegionByParentId = (parentId) => {
  return request({
    url: '/api/v4ward/car/parkSpaceNode/nodeTreeByParentId',
    method: 'get',
    params: {
      parentId,
    },
  });
};

//获取最新客户端版本号
export const latestVersion = () => {
  return request({
    url: '/api/v4ward/car/ParkSpace/merge/latestVersions',
    method: 'get',
  });
};

//获取v4ward道闸消息类型
export const v4wardMessageTypes = () => {
  return request({
    url: '/api/v4ward/car/ParkSpace/merge/messageTypes',
    method: 'get',
  });
};


export const getPassages = param => {
  return request({
    url: '/api/v4ward/car/ParkSpace/merge/passages',
    method: 'get',
    params: {
      parkId: param,
    }
  });
};

export const getPassRuleList = (params, options) =>
  request.get('/api/park/pass/rule/list', Object.assign({}, options, { params }));

export const addPassRule = (params, options) =>
  request.post('/api/park/pass/rule/save', params, options);

export const updatePassRule = (params, options) =>
  request.post('/api/park/pass/rule/update', params, options);

export const stringCheck = (rule, value, callback) => {
  if(rule.min !== undefined && value.length < rule.min){
    callback(new Error('字符长度不能少于' + rule.min));
    return;
  }
  if(rule.max !== undefined && value.length > rule.max){
    callback(new Error('字符长度不能超过' + rule.max));
    return;
  }
  callback();
};

export const numberCheck = (rule, value, callback) => {
  if ((typeof value !== 'number' && isNaN(value))) {
    callback(new Error('请输入数字！'));
  } else if(value < rule.min || value > rule.max){
    callback(new Error('有效数据'+rule.min+'-'+rule.max+'！'));
  } else {
    callback();
  }
};
